import React from 'react';
import './gemgeneve.css'; // Import your CSS file

const GemGeneve = () => {
  return (
    <div className="gem-container">
      {/* Banner Image */}
      <img
        src="/gemg.jpg"
        alt="Royal Rays at GemGeneve"
        className="gem-banner"
      />

      {/* Event Info Section */}
      <h1 className="gem-heading">Event Information</h1>
      <p className="gem-description">
        Join us at GemGeneve 2025, where Royal Rays will showcase our exclusive collection
        of exceptional diamonds and special cuts. Visit our booth to discover the brilliance
        and craftsmanship.
      </p>

      {/* Event Info Cards */}
      <div className="gem-cards">
        <div className="gem-card">
          <h3> Dates</h3>
          <p>May 8–11, 2025</p>
          <p className="gem-subtext">4 Days of Exhibition</p>
        </div>
        <div className="gem-card">
          <h3> Hours</h3>
          <p>10:00 AM – 6:30 PM</p>
          <p className="gem-subtext">Daily Opening Hours</p>
        </div>
        <div className="gem-card">
          <h3> Venue</h3>
          <p>Palexpo Geneva</p>
          <p className="gem-subtext">Geneva, Switzerland</p>
        </div>
        <div className="gem-card">
          <h3> Booth</h3>
          <p>Stand B24</p>
          <p className="gem-subtext">Main Exhibition Hall</p>
        </div>
      </div>

{/* Special Cuts Section */}

{/* Special Cuts Section */}
<div className="special-cuts-section">
  <h2 className="cuts-heading">See Our Special Collection Like Never Before</h2>
  <p className="cuts-subtext">
    Discover Royal Rays' exclusive collection of specially designed diamond cuts,
    each showcasing our commitment to innovation and exceptional craftsmanship.
  </p>

  <div className="cuts-carousel">
    <div className="cut-card">
      <img src="/img1.jpg" alt="Royal Princess Cut" />
      <h3>Octagon</h3>
      <p>Our premium octagon cut with precise facet arrangements that maximize the stone's natural beauty.</p>
    </div>

    <div className="cut-card">
      <img src="/img 2.jpg" alt="Royal Oval Cut" />
      <h3>Shield</h3>
      <p>Our premium shield cut with precise facet arrangements that maximize the stone's natural beauty.</p>
    </div>

    <div className="cut-card">
      <img src="/img 3.jpg" alt="Royal Emerald Cut" />
      <h3>Old Miner</h3>
      <p>Our premium old mine cut with precise facet arrangements that maximize the stone's natural beauty.</p>
    </div>
    <div className="cut-card">
      <img src="/img 4.jpg" alt="Royal Emerald Cut" />
      <h3>Round Rose Cut</h3>
      <p>Our premium round rose cut with precise facet arrangements that maximize the stone's natural beauty.</p>
    </div>
    <div className="cut-card">
      <img src="/img 5.jpg" alt="Royal Emerald Cut" />
      <h3>Hexagon Potrait Cut</h3>
      <p>Our premium hexagon portrait cut with precise facet arrangements that maximize the stone's natural beauty.</p>
    </div>
   
    
  </div>
  <div className="schedule-button-wrapper">
  <a
    href="https://wa.me/917045356688"
    target="_blank"
    rel="noopener noreferrer"
    className="schedule-button"
  >
   Schedule a Meeting
  </a>
</div>
{/* Visit Us Section */}
<section className="visit-section">
  <h2 className="visit-heading">Visit Us at <span>GemGeneve</span></h2>
  <p className="visit-subtext">
    Schedule a personal viewing of our exceptional collection of diamonds and special cuts. 
    Our specialists will be delighted to showcase our latest innovations and discuss your specific needs.
  </p>

  <div className="visit-grid">
    <div className="visit-left">
      <h3>Why Visit Our Booth?</h3>
      <ul>
        <li><strong>✔ Exclusive Viewings</strong><br />Private viewings of our rare and special cut diamonds.</li>
        <li><strong>✔ Expert Consultations</strong><br />Meet our diamond specialists and designers.</li>
        <li><strong>✔ New Releases</strong><br />Be among the first to see our latest diamond cuts and collections.</li>
        <li><strong>✔ Networking</strong><br />Connect with industry professionals and like-minded collectors.</li>
      </ul>

    </div>


    <div className="visit-right">
      <h3>Schedule Your Visit</h3>
      <form>
        <input type="text" placeholder="Full Name*" required />
        <input type="email" placeholder="Email Address*" required />
        <input type="email" placeholder="Phone Number*" required />
        <button type="submit">Submit</button>
      </form>
    </div>
  </div>
</section>


</div>

    </div>


     

  );
};

export default GemGeneve;
